import Vue from "vue";
import App from "./App.vue";
import "./index.css";
import { rtdbPlugin } from "vuefire";
import Toasted from "vue-toasted";

Vue.use(Toasted, { duration: 4000 });
Vue.use(rtdbPlugin);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
